import { IController } from 'angular';
import { ISorterColumnService } from './../../sorter-column/sorter-column.service';
import { SorterColInput } from './sorter-col-input.service';

export class SorterColInputCtrl implements IController {
  static $inject = ['SorterColumn', 'SorterColInput'];

  // bindings
  private ngModel;
  private sorterColumnName;
  private sorterColumnHuman;
  private onChange;
  private placeholder;
  private inputType;
  private items;
  private ngDisabled;

  // local
  private dataType;
  private dataTypeOptions;
  private disabled;
  private label;

  constructor(private SorterColumn: ISorterColumnService, private SorterColInput: SorterColInput) {}

  $onInit() {
    if (!this.sorterColumnName && !this.sorterColumnHuman) {
      throw new Error('sorterColumnName or sorterColumnHuman is required by nvSorterColInput component');
    }

    // The bulk edit modal makes use of human names and therefore does not have access
    // to the column key. This allows for either.
    let sorterColumn;
    if (this.sorterColumnName) sorterColumn = this.SorterColumn.getByColumnKey(this.sorterColumnName);
    if (this.sorterColumnHuman) sorterColumn = this.SorterColumn.getByHumanName(this.sorterColumnHuman);

    if (!sorterColumn) throw new Error('Sorter column specified does not exist');

    this.dataType = sorterColumn.dataType;
    this.dataTypeOptions = sorterColumn.dataTypeOptions;
    this.disabled = this.ngDisabled || (sorterColumn.editable !== null && !sorterColumn.editable);
    this.label = sorterColumn.humanName;
    this.inputType = this.SorterColInput.getInputType(this.inputType, this.dataType);
    this.items = this.SorterColInput.getItems(this.items, this.dataTypeOptions);
  }
}

angular.module('nv.components.sorter-col-input').controller('SorterColInputCtrl', SorterColInputCtrl);
